<template>
  <div class="category-page__wrapper">
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EsputnikService, GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'CategoryPage',
  data () {
    return {
      collectedAnalyticsData: []
    }
  },
  props: {
    categoryName: {
      type: String,
      default: ''
    },
    categoryId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      userDataFromServer: state => state.user.user_data
    })
  },
  methods: {
    async sendAnalyticsData () {
      if (GoogleEnhancedEcommerce.isEnabled) {
        if (this.collectedAnalyticsData.length) {
          await GoogleEnhancedEcommerce.viewItemList({
            analyticsData: this.collectedAnalyticsData,
            listId: this.collectedAnalyticsData[0].item_list_id || this.categoryId,
            listName: this.collectedAnalyticsData[0].item_list_name || this.categoryName
          })
          this.collectedAnalyticsData = []
        }
      }
    },
    collectAnalyticsData (el) {
      this.collectedAnalyticsData.push(el)
    }
  },
  created () {
    if (this.categoryName) {
      EsputnikService.sendCategoryPageInfo({ categoryName: this.categoryName })
    }
  },
  watch: {
    collectedAnalyticsData () {
      setTimeout(() => {
        this.sendAnalyticsData()
      }, 1000)
    }
  }
}
</script>

<style lang="sass">
.category-page__wrapper
  display: flex
  flex-direction: column
  width: 100%
  flex-wrap: nowrap
  //align-items: flex-start

</style>
